exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.table thead tr th[data-v-00083984] {\n  color: #4b536b;\n}\n.table tbody tr[data-v-00083984] {\n  cursor: default;\n}\n.table tbody td[data-v-00083984] {\n  border-top: none;\n}\n.table tbody tr[data-v-00083984]:hover {\n  background-color: #fff;\n  border: none;\n  transform: none;\n  cursor: default;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-00083984","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/PerGroupLearnMore.vue
// module id = 1498
// module chunks = 0